var React = require('react');

function Factory (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15 2v4 2 2h-2l-1-3-4 3-1-3-4 3v11h18V2h-6zm2 2h2v2h-2V4zm0 4h2v11h-2v-1h-2v1h-2v-1h-2v1H9v-1H7v1H5v-8l.98-.734.123.367.877 2.633L9.199 11.6l1.781-1.334.123.367.455 1.367H13h2 2v-2-2zM7 14v2h2v-2H7zm4 0v2h2v-2h-2zm4 0v2h2v-2h-2z"}));
}

Factory.defaultProps = {"viewBox":"0 0 24 24","xmlnsV":"https://vecta.io/nano"};

module.exports = Factory;

Factory.default = Factory;
